/**
 * Whether a link opens a Restaurant Account screen — the ones the router
 * shows only in that mode (/admin and /admin/*, router/index.js) plus the
 * legacy URLs that redirect there. A notification for a restaurant's team
 * opens one, so tapping it from the personal account switches mode first
 * (Kapil, 2026-09-25). RM's own admin pages (/admin-support,
 * /admin-member-highlights…) are NOT restaurant screens.
 */
const LEGACY_RESTAURANT_PATHS = ['/ra-messages', '/restaurant-bookings']

export function isRestaurantAccountPath(link) {
  const path = String(link || '').split(/[?#]/)[0]

  return path === '/admin' || path.startsWith('/admin/') || LEGACY_RESTAURANT_PATHS.includes(path)
}
